export function optionalProp<K extends string, V>(key: K, value: V | undefined): Partial<Record<K, V>> {
  if (value === undefined) {
    return {} as Partial<Record<K, V>>;
  }

  return { [key]: value } as Partial<Record<K, V>>;
}
